import React from "react";
import { FormikProps, withFormik } from "formik";
import { FormStack } from "../components/FormStack/FormStack";
import {
  IntegrationFeatureProps,
  IntegrationGetMMSListParameter,
} from "../components/Integration/IntegrationsFeatureParameter";
import {
  ChakraReactSelectField,
  SelectOption,
} from "../components/fields/SelectField/ChakraReactSelectField";
import { SingleValue } from "chakra-react-select";

interface GetIntegrationMMSListParameterFormValues
  extends IntegrationGetMMSListParameter {}

interface GetIntegrationMMSListParameterFormProps
  extends IntegrationFeatureProps {
  types: string[] | null;
  typesIsLoading: boolean;
}

const InnerForm = ({
  setFieldValue,
  setFieldFeatureValue,
  types,
  typesIsLoading,
}: GetIntegrationMMSListParameterFormProps &
  FormikProps<GetIntegrationMMSListParameterFormValues>) => {
  return (
    <FormStack>
      <ChakraReactSelectField
        horizontal
        label="Type Id"
        name="type"
        selectedOptionColor="blue"
        className="relative-listbox"
        isLoading={typesIsLoading}
        options={
          types?.map((data) => {
            return {
              label: data,
              value: data,
            };
          }) || []
        }
        onChange={(e) => {
          const value = (e as SingleValue<SelectOption>)?.value;
          setFieldValue("type", value);
          setFieldFeatureValue("type", value);
        }}
      />
    </FormStack>
  );
};

export const GetIntegrationMMSListParameterForm = withFormik<
  GetIntegrationMMSListParameterFormProps,
  GetIntegrationMMSListParameterFormValues
>({
  mapPropsToValues: ({ feature }) => {
    if (!feature.parameter) {
      feature.parameter = {};
    }
    return { type: feature.parameter?.type };
  },
  handleSubmit: async (values, { props, setFieldError }) => {},
  validateOnBlur: false,
  validateOnMount: false,
  validateOnChange: false,
})(InnerForm);
